import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { AiTurnDetail } from "../../aiConversations.types";
import {
  AiConversationSubRoute,
  ApiRoutesAiConversations
} from "../../constants/enums";
import { GetTurnDetailParams } from "./getTurnDetail.types";

export const requestGetTurnDetail = async ({
  conversationId,
  turnMessageId
}: GetTurnDetailParams): Promise<AiTurnDetail> =>
  await instance.get(
    buildUrl(
      ApiRoutesAiConversations.Conversations,
      conversationId,
      AiConversationSubRoute.Turns,
      turnMessageId
    )
  );
